import { storageItemContentTypes } from "./content-types";

// TODO! THIS WON'T WORK FOR ALL FUTURE FILE TYPES
const fileTypes = storageItemContentTypes.map(item =>
    // remove everything up until and including the first slash
    // e.g. "image/png" -> "png"
    // and everything after a +
    // e..g "image/svg+xml" -> "svg"
    item.replace(/^(\/|\w.*\/)(\w.*?)(\+.*)?$/gi, "$2")
);

export { fileTypes };
